export const apiField = 'topographical_factor_kzt';
export default {
  type: 'Text',
  label: 'topographicalFactorKzt',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

